<template>
  <div class="h-full w-full flex justify-center items-center">
    <div class="bg-white relative rounded" :style="styles">
      <div class="w-full left-0 absolute">
        <div class="px-10 pt-4">
          <div class="default--message py-1 flex px-2 items-center">
            <span class="text-zt-xl"><zt-icon name="info-circle-alt"/></span>
            <p class="text-center w-full font-normal">
              {{ $t('message.abm.folders.emptyState.title') }}
              <span class="cursor-pointer underline font-medium" @click="showFileDialog" data-vs-button="showFileDialog">
                {{ $t('message.abm.folders.emptyState.link') }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PdfEmptyState",
  props: {
    emptySize: {
      type: Object,
      default: {
        width: '595px',
        height: '842px'
      }
    }
  },
  inject: ['showFileDialog'],
  computed: {
    styles() {
      if (this.emptySize.width <= 0 || this.emptySize.height <= 0) {
        return {
          width: '595px',
          height: '842px'
        }
      }
      return {
        width: `${this.emptySize.width}px`,
        height: `${this.emptySize.height}px`,
      }
    }
  }
}
</script>

<style scoped>
.default--message {
  background-color: rgba(196, 196, 196, 0.5);
  border-radius: 5px;
}
</style>